// extracted by mini-css-extract-plugin
module.exports = {"container":"Select_container__xMbaF","select":"Select_select__1rW66","placeholderShimmer":"Select_placeholderShimmer__3j_Im"};